import { createSlice } from "@reduxjs/toolkit";
import { getScheduleTime } from "./thunk"; // Import the async thunks

const initialState = {
  scheduleTime:[],
  loading:false
};

const TimeSlice = createSlice({
  name: "TimeSlice",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
  
      builder
        .addCase(getScheduleTime.pending, (state) => {
          state.loading = true;
          state.scheduleTime = []
        })
        .addCase(getScheduleTime.fulfilled, (state, action) => {
          state.loading = false;
          state.scheduleTime = action.payload
        })
        .addCase(getScheduleTime.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });

  },
  

});

export default TimeSlice.reducer;
